import React from 'react';

export default function BlurredOverlay({ children, blurred, lang }) {
  if (!blurred) return children;
  const ar = lang === 'ar';
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none' }}>
        {children}
      </div>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: 'rgba(255,255,255,0.9)', borderRadius: 16, padding: '1.5rem 2rem', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: '1.5rem', marginBottom: '0.3rem' }}>🔒</div>
          <p style={{ fontSize: '0.85rem', color: '#0c1425', fontWeight: 600 }}>
            {ar ? 'أدخل بريدك الإلكتروني لعرض النتائج' : 'Entrez votre email pour voir les résultats'}
          </p>
        </div>
      </div>
    </div>
  );
}
